import { render, staticRenderFns } from "./DashboardPieCard.vue?vue&type=template&id=61a25860&scoped=true&"
import script from "./DashboardPieCard.vue?vue&type=script&lang=js&"
export * from "./DashboardPieCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPieCard.vue?vue&type=style&index=0&id=61a25860&lang=scss&scoped=true&"
import style1 from "./DashboardPieCard.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./DashboardPieCard.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a25860",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardCardTitle: require('/workspace/components/Dashboard/DashboardCardTitle.vue').default})
